// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-tip {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.tool-tip.tooltip-hidden {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}
.tool-tip.tooltip-hidden .handle-button {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
  background-color: transparent;
}
.tool-tip.tooltip-hidden .handle-button .icon {
  display: none;
}
.tool-tip .handle-button {
  width: 18px;
  height: 18px;
  border-radius: 15px;
  border: 1px solid var(--white-color-light);
  cursor: pointer;
  transition: box-shadow 0.3s;
  background-color: var(--font_active_sub_color);
  color: var(--white-color-lightest);
  display: flex;
  justify-content: center;
}
.tool-tip .tool-tip-float-area {
  position: fixed;
  z-index: var(--z-index-tooltip);
}
.tool-tip .tool-tip-float-area .tool-tip-float-area-group {
  position: relative;
}
.tool-tip .tool-tip-float-area .tool-tip-float-area-group .tool-tip-float {
  width: 296px;
  height: fit-content;
  position: relative;
  z-index: var(--z-index-local-default);
  background-color: var(--dark-color-dark-transparent-75);
  color: var(--white-color-lightest);
  font-size: var(--text-size-small);
  padding: 8px 12px;
}
.tool-tip .tool-tip-float-area .tool-tip-float-area-group .tool-tip-float-shadow {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  box-shadow: var(--omni-shadow-hidden);
  z-index: var(--z-index-local-under-1);
  border-radius: 8px;
  background-color: transparent;
}
.tool-tip .close-button {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Tooltip.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACD;AACC;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACF;AACE;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AACH;AACG;EACC,aAAA;AACJ;AAIC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,eAAA;EACA,2BAAA;EACA,8CAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;AAFF;AAKC;EACC,eAAA;EACA,+BAAA;AAHF;AAKE;EACC,kBAAA;AAHH;AAIG;EACC,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,uDAAA;EACA,kCAAA;EACA,iCAAA;EACA,iBAAA;AAFJ;AAIG;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,qCAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AAFJ;AAOC;EACC,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AALF","sourcesContent":[".tool-tip {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tposition: relative;\r\n\r\n\t&.tooltip-hidden{\r\n\t\tposition: absolute;\r\n\t\ttop: 0;\r\n\t\tbottom: 0;\r\n\t\tleft: 0;\r\n\t\tright: 0;\r\n\t\tmargin: auto;\r\n\t\theight: 100%;\r\n\t\twidth: 100%;\r\n\r\n\t\t.handle-button{\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 0;\r\n\t\t\tbottom: 0;\r\n\t\t\tleft: 0;\r\n\t\t\tright: 0;\r\n\t\t\tmargin: auto;\r\n\t\t\theight: 100%;\r\n\t\t\twidth: 100%;\r\n\t\t\tbackground-color: transparent;\r\n\r\n\t\t\t.icon{\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\t\r\n\t\t}\r\n\t}\r\n\r\n\t.handle-button {\r\n\t\twidth: 18px;\r\n\t\theight: 18px;\r\n\t\tborder-radius: 15px;\r\n\t\tborder: 1px solid var(--white-color-light);\r\n\t\tcursor: pointer;\r\n\t\ttransition: box-shadow 0.3s;\r\n\t\tbackground-color: var(--font_active_sub_color);\r\n\t\tcolor: var(--white-color-lightest);\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t}\r\n\r\n\t.tool-tip-float-area {\r\n\t\tposition: fixed;\r\n\t\tz-index: var(--z-index-tooltip);\r\n\r\n\t\t.tool-tip-float-area-group{\r\n\t\t\tposition: relative;\r\n\t\t\t.tool-tip-float{\r\n\t\t\t\twidth: 296px;\r\n\t\t\t\theight: fit-content;\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tz-index: var(--z-index-local-default);\r\n\t\t\t\tbackground-color: var(--dark-color-dark-transparent-75);\r\n\t\t\t\tcolor: var(--white-color-lightest);\r\n\t\t\t\tfont-size: var(--text-size-small);\r\n\t\t\t\tpadding: 8px 12px;\r\n\t\t\t}\r\n\t\t\t.tool-tip-float-shadow{\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 0;\r\n\t\t\t\tbottom: 0;\r\n\t\t\t\tright: 0;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\tbox-shadow: var(--omni-shadow-hidden);\r\n\t\t\t\tz-index: var(--z-index-local-under-1);\r\n\t\t\t\tborder-radius: 8px;\r\n\t\t\t\tbackground-color: transparent;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.close-button {\r\n\t\tposition: fixed;\r\n\t\ttop: 0;\r\n\t\tright: 0;\r\n\t\tbottom: 0;\r\n\t\tleft: 0;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
